
var lib = require("string-similarity");

export const stringSimilarity = (a, b) => {
  return lib.compareTwoStrings(a, b)
}
